<template>
    <tr>
        <td>{{ currency }}</td>
        <td>{{ balance }}</td>
        <td>
            <label class="switch">
                <input type="checkbox" 
                    :value="currency"
                    :checked="is_checked === true?'checked':''" 
                    @change="checkHendler($event)"
                >
                <span class="slider round"></span>
            </label>
        </td>
    </tr>
</template>

<script>
import Account from '@/services/Account';
export default{
    data(){
        return{
            balance:'',
            is_checked:false,
            selected_currency:''
        }
    },
    props:['currency','userNo','index','default_currency'],
    methods:{
        checkHendler($event){
            console.log(this.default_currency.length);
            if(this.is_checked === false && this.default_currency.length>2){
                $event.target.checked = false;
            }
            else if(this.is_checked === false){
                this.$emit('set-balance',this.balance,this.currency);
                this.is_checked = true;
            }
            else if(this.is_checked === true && this.default_currency.length<=1){
                this.is_checked = true;
                $event.target.checked = true;
            }
            else{
                this.$emit('remove-balance',this.balance,this.currency);
                this.is_checked = false;
            }
        }
    },
    watch: {
        default_currency(newVal, oldVal) {
        
        }
    },
    mounted(){
        Account.getBalance({
            "userNo":this.userNo,
            "ccy":this.currency
        }).then((response)=>{
            let data = response.data.data.data;
            this.balance=data.availableBal;
            if(this.default_currency.includes(this.currency)){
             this.$emit('set-balance',this.balance,this.currency);
             this.is_checked = true;
            }
        });
    }
}
</script>
